import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconRefreshOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M5.739 7.115v5.016c0 4.62 3.76 8.38 8.38 8.38s8.381-3.76 8.381-8.38-3.76-8.381-8.381-8.381v-1.5C19.567 2.25 24 6.683 24 12.131c0 5.447-4.433 9.88-9.881 9.88-5.447 0-9.88-4.433-9.88-9.88V7.115L1.28 10.074a.75.75 0 0 1-1.061-1.06l4.77-4.77 4.77 4.77a.75.75 0 0 1-1.061 1.06zm-1.5-.807h1.5z" /></svg>
);
